import { render, staticRenderFns } from "./RSectionHeader.vue?vue&type=template&id=487cc48e&scoped=true&"
import script from "./RSectionHeader.vue?vue&type=script&lang=js&"
export * from "./RSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RSectionHeader.vue?vue&type=style&index=0&id=487cc48e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cc48e",
  null
  
)

export default component.exports